var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('BlurredTenant',{attrs:{"showBlur":_vm.showBlur}},[_c('x-default-data-table',{key:_vm.forceRecompute,attrs:{"x-options":_vm.tableOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }